import type { CurveGeometry } from '../types.ts';
import { buildHilbert } from './hilbert.ts';
import { buildQuaquaversal } from './quaquaversal.ts';

export type GeneratorFn = (params: Record<string, number>) => CurveGeometry;

/** Procedural geometry sources. Each returns the same CurveGeometry shape a fetched file decodes to. */
export const GENERATORS: Record<string, GeneratorFn> = {
  hilbert: (p) => buildHilbert(p.order ?? 1),
  quaquaversal: (p) => buildQuaquaversal(p.depth ?? 1),
};
